import { Integration, IntegrationType } from "../../../../types"

export const TYPE_LABELS: Record<IntegrationType, string> = {
  api: "API embed",
  boomtown: "LO page embed",
  widget: "Full embed",
  standalone: "Standalone embed",
  chatbot: "Website chat embed",
  button: "Button embed",
  standalone_pricing: "Standalone pricing"
}

export function getFeatureTags(integration: Integration): string[] {
  const { type, app_settings } = integration

  if (type === "chatbot") return ["Chat"]

  if (!app_settings) return []

  const tags: string[] = []
  if (app_settings.lead_workflow) tags.push("Lead Workflow")
  if (app_settings.rate_table_config) tags.push("Rate Table")
  if (app_settings.pricing === 1) tags.push("Pricing Cards")
  if (app_settings.mort_calc || app_settings.afford_calc)
    tags.push("Calculators")
  if (app_settings.settings?.loReviews || app_settings.settings?.brandReviews)
    tags.push("Reviews")
  if (app_settings.settings?.contactForm) tags.push("Contact Form")
  if (app_settings.settings?.aboutBoxes) tags.push("About Boxes")
  return tags
}
